import React from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import TextareaAutosize from 'react-textarea-autosize';

import InfoSquareIcon from '../../assets/gptw_icons/Icons_rot/info-square.png';

const FormField = ({ 
    label, 
    name, 
    value, 
    onChange, 
    tooltip, 
    placeholder, 
    minRows = 4,
    readOnly = false,
    className = '' 
}) => (
    <Form.Group controlId={`form${name}`} className="mt-3">
        <Form.Label className="d-flex align-items-center">
            {label}
            {tooltip && (
                <OverlayTrigger placement="right" overlay={<Tooltip id={`${name}-tooltip`}>{tooltip}</Tooltip>}>
                    <img
                        src={InfoSquareIcon}
                        alt="Info"
                        style={{
                            marginLeft: '8px',
                            cursor: 'pointer',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </OverlayTrigger>
            )}
        </Form.Label>
        <TextareaAutosize
            minRows={minRows}
            className={`form-control mb-3 ${readOnly ? 'readonly-field' : ''} ${className}`}
            name={name}
            value={value || ''}
            onChange={onChange}
            placeholder={placeholder}
            readOnly={readOnly}
            style={readOnly ? {
                backgroundColor: '#f8f9fa',
                cursor: 'default',
                opacity: 0.85,
                color: '#495057',
                resize: 'none'
            } : {}}
        />
    </Form.Group>
);

export default FormField;